<template>
    <div class="share-wrapper" v-if="EmbedItem">
        <vs-tabs>
            <vs-tab :label="'1. Select people'" icon-pack="feather" icon="icon-users">
                <div class="vx-col xl:w-12/12 lg:w-12/12 md:w-12/12 w-12/12 mb-base">
                    <vs-input v-model="emails" placeholder="jane@test.com, john@test.com" type="email"
                        style="width:100%;" @keyup="SetEmail">
                    </vs-input>
                    <vs-table :data="users" style="width:100% !important; overflow:hidden;">
                        <template slot="thead">
                            <vs-th>Email</vs-th>
                            <vs-th>Workflow</vs-th>
                            <!-- <vs-th>Deadline</vs-th> -->
                            <!-- <vs-th>Nro1</vs-th>
                                <vs-th>Nro2</vs-th> -->
                        </template>

                        <template slot-scope="{data}" style="overflow:hidden !important;">
                            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                                <vs-td :data="tr.email" style="vertical-align: top;">
                                    {{ tr.email }}
                                    <template slot="edit">
                                        <vs-input v-model="tr.email" class="inputx" placeholder="Email" />
                                    </template>
                                </vs-td>

                                <vs-td :data="tr.username"  style="vertical-align: top;">
                                    <vs-select v-model="tr.Workflow" class="w-full select-large">
                                        <vs-select-item :key="index" :value="item.Id" :text="item.Title"
                                            v-for="(item, index) in Workflows" class="w-full" />
                                    </vs-select><br />
                                    <!-- <datepicker v-model="tr.Deadline"></datepicker> -->
                                </vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>
                </div>
            </vs-tab>
            <vs-tab :label="'2. Set settings'" icon-pack="feather" icon="icon-settings">
                Shares link to this article in the system.
            </vs-tab>
            <vs-tab :label="'3. Share Emails'" icon-pack="feather" icon="icon-mail">
                <div class="vx-row">
                    <div class="vx-col  xl:w-1/2 lg:w-1/2 md:w-2/3 w-4/5 mb-base">
                        <vs-checkbox v-model="SendOnboardingLinks">
                            Ask users to mark as onboarded?
                        </vs-checkbox>
                    </div>
                    <div class="vx-col  xl:w-1/2 lg:w-1/2 md:w-2/3 w-4/5 mb-base">
                        <vs-checkbox v-model="WorkflowForEachItem">
                            Repeat workflow for each item
                        </vs-checkbox>
                    </div>
                    <div class="vx-col  xl:w-1/2 lg:w-1/2 md:w-2/3 w-4/5 mb-base">
                        <vs-checkbox v-model="SendSection">
                            Include the entire section
                        </vs-checkbox>
                    </div>
                    <div class="vx-col  xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5 mb-base">
                        <vs-checkbox v-model="AddCurrentUserInTo">
                            Add me in the "To"
                        </vs-checkbox>
                    </div>
                </div>
                <div class="vx-row">
                    <div class="vx-col  xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5 mb-base">
                        <vs-select v-model="Importance" class="w-full select-large" label="Importance:">
                            <vs-select-item :key="index" :value="item.Value" :text="item.Title"
                                v-for="(item, index) in ImprotanceStages" class="w-full" />
                        </vs-select>
                    </div>
                </div>
                <div class="vx-row">
                    <div class="vx-col  xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5 mb-base">

                    </div>
                </div>
                <div class="vx-row">
                    <div class="vx-col  xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5 mb-base">
                        <vs-button color="success" type="gradient" icon-pack="feather" icon="icon-mail"
                            @click="ShareEmbed">Share</vs-button>
                    </div>
                </div>
            </vs-tab>
        </vs-tabs>
    </div>
</template>

<script>

import AssignmentService from "@/assignments/assignmentsService.js";
import WorkflowService from "@/workflows/workflowService.js";
import Datepicker from 'vuejs-datepicker';

export default {
    data() {
        return {
            emails: null,
            SendOnboardingLinks: true,
            SendSection: false,
            AddCurrentUserInTo: false,
            WorkflowForEachItem: false,
            Importance: "I",
            ImprotanceStages: [{
                Title: "Action Required",
                Value: "AR"
            }, {
                Title: "Informational",
                Value: "I"
            }],
            Workflow: null,
            Workflows: null,
            users: []
        }
    },
    mounted() {
        var instance = this;
        WorkflowService.GetWorkflows().then(function (response) {
            instance.$set(instance, "Workflows", response.data);
        });
    },
    methods: {
        ShareEmbed() {
            var instance = this;
            AssignmentService.shareEmailAssignments(
                this.users,
                this.SendOnboardingLinks,
                this.SendSection,
                this.EmbedItem.data.Id,
                this.AddCurrentUserInTo,
                this.Importance,
                this.WorkflowForEachItem)
                .then(function (response) {
                    instance.$vs.notify({
                        title: "Success",
                        text: "Invitations sent.",
                        color: "success",
                        iconPack: "feather",
                        icon: "icon-check",
                        time: 8000,
                    });
                });
        },
        SetEmail(evt) {
            if (evt.keyCode == 13) {
                this.users.push({
                    email: this.emails,
                });
                this.emails = '';
            }
        }
    },
    props: [
        "EmbedItem"
    ],
    components: {
        Datepicker
    }
}
</script>

<style scoped>
*>>>.share-wrapper {
    min-height: 400px;
    min-width: 80%;
}
</style>